<template>
  <auto-complete v-model.trim="search" :transfer="true" icon="md-search">
    <div v-if="filtered_numbers.length === 0" class="ivu-select-not-found">
      {{ $t('i.select.noMatch') }}
    </div>
    <div class="autocomplete-items-wrapper">
      <i-option-group v-if="internals.length" :label="$tc(`pbx.number.type.internal`, 1)">
        <i-option
          v-for="option in internals"
          :key="option.id"
          :value="option.number"
          :label="option.number"
        />
      </i-option-group>

      <i-option-group v-if="externals.length" :label="$tc('pbx.number.type.external', 1)">
        <i-option
          v-for="option in externals"
          :key="option.id"
          :value="option.number"
          :label="option.number"
        />
      </i-option-group>
    </div>

    <a href="javascript:void(0)" class="autocomplete-more" @click="$emit('create-button')">
      {{ $t(`pbx.worksheet.action.entry.state.create-number.title`) }}
    </a>
  </auto-complete>
</template>

<script>
  import { NumberService } from '@pbx/services/NumberService';
  import { filterNumberStrict } from '@shared/helpers/filter';

  export default {
    props: {
      value: {
        type: Number,
        default: null
      }
    },

    data() {
      return {
        numbers: [],
        search: ''
      };
    },

    computed: {
      filtered_numbers: function() {
        return this.numbers.filter(item => filterNumberStrict(this.search, item.number));
      },

      externals: function() {
        return this.filtered_numbers.filter(number => number.type === 'external');
      },

      internals: function() {
        return this.filtered_numbers.filter(number => number.type === 'internal');
      }
    },

    watch: {
      value: {
        handler: function(id) {
          this.get_number_from_value(id);
        },
        immediate: true
      },

      search: function(search) {
        if (search.length > 0) {
          const find_number = this.numbers.find(item => item.number === search);
          if (find_number) {
            this.$emit('input', find_number.id);
          } else {
            this.$emit('input', null);
          }
        } else {
          this.$emit('input', null);
        }
      }
    },

    created() {
      NumberService.getForScheme()
        .then(numbers =>
          numbers.map(number => {
            if (number.id === this.value) {
              return { ...number, used: false };
            }

            return number;
          })
        )
        .then(numbers => numbers.filter(number => !number.used))
        .then(numbers => (this.numbers = numbers))
        .then(() => this.get_number_from_value(this.value));
    },

    methods: {
      get_number_from_value: function(id) {
        const find_number = this.numbers.find(item => item.id === id);
        if (find_number) {
          this.search = find_number.number;
        }
      }
    }
  };
</script>

<style lang="scss">
  .autocomplete-items-wrapper {
    max-height: 195px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .autocomplete-more {
    display: inline-block;
    width: 100%;
    text-align: center;
    border-top: 1px solid #ddd;
    padding: 8px 0 4px 0;
    font-size: 12px;
  }
</style>
